<p-toast></p-toast>
<main
    #mainContainer
    class="h-100 w-100 overflowHidden flex justify-content-center mainContainer"
>
    <!-- Drag-and-drop overlay -->
    <div *ngIf="showDragOverlay && isDragDropAllowed();" class="drag-overlay">
        <i class="pi pi-upload drag-overlay-icon"></i>
        <p>Drop files here to add to chat</p>
    </div>
    <div *ngIf="showDragOverlay && !isDragDropAllowed();" class="drag-overlay">
        <i class="pi pi-ban drag-overlay-icon-restricted"></i>
        <p>Cannot upload files until previous upload is complete</p>
    </div>
    <section
        class="contentSection spaceBetween empty-layout"
    >

        <!-- Loader -->
        <section
            *ngIf="loadingChats"
            class="flex flex-column justify-content-center message-body"
        >
            <div class="loading">
                <app-loader [isLoading]="loadingChats"></app-loader>
            </div>
        </section>

        <!-- Download Button -->
        <button *ngIf="!loadingChats && chatMessages?.length>0 && chatDocsProcessingCount===0"
          pTooltip="Download Chat"
          tooltipPosition="left"
          showDelay="300"
          class="defaultBtn sharebtn p-button p-button-outlined"
          (click)="downloadInteractionContainerHTML()">
          <i class="bi bi-download p-0 m-0"></i>
        </button>

        <!-- Chat Questions & Response -->
        <section
            *ngIf="!loadingChats"
            class="w-100"
            [ngClass]="chatMessages?.length > 0  ? 'flex flex-column-reverse message-body' : ''"
        >
            <div class="scroll-y chat-container" #scrollContainer>
                <div class="flex flex-column">
                    <section class="chatdocsContainer">
                        <div class="filtersContainer" [ngClass]="{'filtersContainerMargin': chatMessages?.length === 0}">
                            <ng-container>
                                <app-chat-document
                                (chatDocsProcessingCount)="updatechatDocsProcessing($event)"
                                (reloadInteractions)="checkDocSummary($event)" #chatDocuments>
                                </app-chat-document>
                            </ng-container>
                        </div>
                    </section>
                    <div *ngIf="chatMessages?.length>0 && chatDocsProcessingCount===0" class="flex flex-column width-100 scroll-container">
                        <div
                            #interactionContainer
                            *ngFor="let interaction of chatMessages; let i = index; trackBy: trackByInteractionId"
                            [attr.data-id]="interaction.interactionId"
                            class="mt-2 mb-0 "
                        >
                            <div
                                *ngIf="
                                    interaction['request']?.requestText.trim() !== ''
                                "
                                class="mt-4"
                            >
                                <app-chat-question
                                    [interaction]="interaction.request"
                                    [interactionId]="interaction.interactionId"
                                    [showContextLimitError]="
                                        activeChat.maxTokenContextIndex >= i
                                    "
                                    [activeChat]="activeChat"
                                    [questionImages]="
                                        currentQuestionImages[interaction.interactionId]
                                    "
                                    (editQuestion)="handleEditedQuestion($event)"
                                ></app-chat-question>
                            </div>
                            <div *ngIf="interaction['response']">
                                <app-chat-response
                                    (scrollToBottom)="scrollOnRespGeneration($event)"
                                    (regenerate)="regenerateResponse()"
                                    [interaction]="interaction"
                                    [responseLength]="
                                        interaction.response.length === 0
                                            ? 0
                                            : interaction.response.length - 1
                                    "
                                    [lastInteraction]="
                                        i === chatMessages.length - 1 ? true : false
                                    "
                                    [showTypeWriter]="
                                        i === chatMessages.length - 1 &&
                                        showTypeWriterResponse
                                    "
                                    [showRegenerationButton]="
                                        i === chatMessages.length - 1 &&
                                        showRegenerationButton
                                    "
                                    [chatReply]="chatReply"
                                    [isStructuredChat]="isStructutredChat"
                                    [reasoningSummary]="reasoningSummary"
                                    [progressSummary]="progressSummary"
                                ></app-chat-response>
                            </div>
                            <div
                                *ngIf="
                                    i === chatMessages?.length - 1 &&
                                    (activeChat?.chatState === ChatStateInactive || activeChat?.chatState === ChatStateArchived)
                                "
                                class="inactiveChat inactiveText"
                            >
                               <span>
                                    <p *ngIf="activeChat?.chatState === ChatStateInactive">
                                        Chat is inactive as the attached documents are
                                        not available
                                    </p>
                                    <p *ngIf="activeChat?.chatState === ChatStateArchived">
                                        Chat is archived and can&apos;t accept new messages
                                    </p>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <div *ngIf="chatMessages?.length === 0 && !loadingChats && chatDocsProcessingCount===0" class="chat-hero">
            <div
                class="flex flex-column justify-content-center align-items-center chatDetails text-center"
            >
                <div
                    class="aboutChat"
                    *ngIf="
                        (chatMessages?.length === 0 &&
                        (!activeChat || activeChat?.chatDocument?.length === 0) &&
                            filesUploadedImgUrls.length === 0 &&
                            chatType !== ESGChatType &&
                            chatType !== codeInterpreterChatType &&
                            chatType !== QECChatType &&
                            chatType !== deepResearchChatType &&
                            chatType !== quiltChatType) && 
                            chatDocsProcessingCount===0 && 
                            (!chatDocuments || chatDocuments?.documentsList?.length ===  0)
                    "
                >
                    <p class="text-center aboutChatHeader">
                        How can I assist you today ?
                    </p>

                    <p *ngIf="chatType===openWebChatType"
                        class="aboutChatCaution">
                        ⚠ <strong>Caution:</strong> Open Web Chat is Not Data Protected.
                        This chat operates in an open web environment and is not secured for confidential or sensitive data.
                        Please avoid sharing proprietary, confidential, or sensitive data.
                        For secure discussions, use other QIQ communication tools.
                        By continuing, you acknowledge these risks.
                    </p>
                </div>
                <div
                    class="aboutChat"
                    *ngIf="
                        chatMessages?.length === 0 &&
                        chatType === codeInterpreterChatType &&
                        !loadingChats
                    "
                >
                    <p class="text-center aboutChatHeader">Data Science Playground</p>
                    <p class="text-center subAboutChat">
                        Hello, I'm here to assist you with generating custom images and charts.
                        Whether you need visualizations for data analysis, presentations, or reports,
                        I have a wide range of tools and resources at my disposal, including libraries
                        and frameworks to achieve the task.
                        Feel free to ask any questions or request specific types of charts and images.
                    </p>
                </div>
                <div
                    class="aboutChat"
                    *ngIf="
                        chatMessages?.length === 0 &&
                        chatType === deepResearchChatType &&
                        !loadingChats
                    "
                >
                    <p class="text-center aboutChatHeader">Deep Research</p>
                    <p class="text-center subAboutChat">
                        Deep Research goes beyond the surface. Provide a topic for structured insights. 
                        I adapt to any detail, from quick clarifications to in-depth reports.
                        I analyze and synthesize hundreds of sources, so a thorough response takes several minutes
                    </p>
                    <p class="text-center aboutChatCaution">
                        ⚠ <strong>Caution: Deep Research is not data protected.</strong> 
                        This is an unsecured chat. Do not share proprietary, confidential, or sensitive data.
                        Use other QIQ tools for secure discussions. By continuing, you acknowledge these risks.
                    </p>
                </div>
                <div
                    class="aboutChat"
                    *ngIf="
                        chatMessages?.length === 0 &&
                        chatType === ESGChatType &&
                        !loadingChats &&( !activeChat || (
                        activeChat?.chatTables?.length === 0 &&
                        !activeChat?.chatConfig?.ESGChat &&
                        !activeChat?.ESGTableTags?.length === 0))
                    "
                >
                    <p class="text-center aboutChatHeader">ESG</p>
                    <p class="text-center subAboutChat">
                        Hello, I'm available to help you with any questions you
                        might have about the ESG domain. I have a vast array of
                        resources on ESG at my disposal, including research
                        papers, books, articles, and newsletters.
                    </p>
                </div>
                <div
                    class="aboutChat"
                    *ngIf="
                        chatMessages?.length === 0 &&
                        chatType === QECChatType&&
                        !loadingChats &&( !activeChat ||
                        activeChat?.chatTables?.length === 0 ) &&
                        !(chatType===QECChatType && defaultWFDOTables.length)
                    "
                >
                    <p class="text-center aboutChatHeader">WFDO</p>
                    <p class="text-center subAboutChat">
                        The analysis and optimization of data related to the flow of oil and gas from wells
                        </p>
                    <p class="aboutNote">
                        Note: Please select tables to initiate the WFDO chat
                    </p>
                </div>
                <div
                    class="aboutChatLarge quilt-hero"
                    *ngIf="
                        chatMessages?.length === 0 &&
                        chatType === quiltChatType&&
                        !loadingChats
                    "
                >
                    <p class="text-center aboutChatHeader">QUILT</p>
                    <p class="text-center subAboutChat">
                        QUILT (Quantum Investment Lifecycle Tracker) manages key investment activities for portfolio companies (PCs), including capital commitments, calls, distributions, valuations, and reviews. Users can query QUILT data about PCs through QIQ using natural language for quick insights.
                    </p>
                    <div
                        *ngIf="suggestedQuestions?.length"
                    >
                        <app-chat-hero-suggested-questions
                            [suggestedQuestions]="suggestedQuestions"
                            (questionClick)="setInputText($event)"
                        ></app-chat-hero-suggested-questions>
                    </div>
                </div>
            </div>
        </div>

        <div class="input-container">
            <div
                *ngIf="lastMessage?.response?.at(-1)?.suggestedQuestions?.length &&
                !generatingReplyBool &&
                !loadingChats &&
                chatMessages?.length > 0 &&
                activeChat?.chatState === ChatStateActive"
                class="suggested-questions"
            >
                <app-chat-response-suggested-questions 
                    [suggestedQuestions]="lastMessage?.response?.at(-1)?.suggestedQuestions"
                    (questionClick)="setInputText($event)"
                ></app-chat-response-suggested-questions>

            </div>
            <div
                class="flex justify-content-start my-0 mr-5 regenerationResp imagesContainer"
                *ngIf="filesUploaded.length > 0"
            >
                <div
                    class="image-card regenBtn"
                    *ngFor="let file of filesUploadedImgUrls; let i = index"
                >
                    <button
                        *ngIf="!file.loading"
                        class="image-cancel-icon"
                        (click)="removeFile(i)"
                    >
                        <i class="bi bi-x-circle-fill"></i>
                    </button>
                    <img
                        [src]="file.url"
                        [ngClass]="file.loading ? 'imgBackgroundLoad' : ''"
                        class="uploaded-image"
                        alt="Uploaded"
                    />
                    <div *ngIf="file.loading" class="image-loader">
                        <i class="pi pi-spinner pi-spin spinnerColor"></i>
                    </div>
                </div>
            </div>
            <p-overlayPanel #opdocs>
                <input
                    type="file"
                    class="form-control hidden"
                    #fileUploadDoc
                    (change)="onFIleuploadForDocChat($event)"
                    accept=".pdf, .ppt, .pptx, .docx, .txt, .csv, .xlsx, .xls"
                    multiple
                />
                <p-overlayPanel class="overlayStyles uploadstyles" style="padding: 0px !important;"  #op>
                    <div>
                        <div class="m-2">
                            <button
                                class="p-button p-button-secondary attachBtn w-full text-left"
                                (click)="fileUploadDoc.click(); op.hide(); opdocs.hide()"
                            >
                                <i class="bi bi-upload mr-2"></i>Load from computer
                            </button>
                        </div>
                        <hr>
                        <div class="m-2">
                            <button
                                class="p-button p-button-secondary attachBtn w-full text-left mt-1"
                                (click)="showDocuments(); op.hide(); opdocs.hide()"
                            >
                                <i class="bi bi-folder mr-2"></i> Select documents from QIQ
                            </button>
                        </div>
                    </div>
                </p-overlayPanel>
                <div class="flex spaceBetween m-2">
                    <button class="button addFileBtn" (click)="op.toggle($event)">
                        <i class="bi bi-plus mr-1"></i> Add File
                    </button>
                </div>
                <hr>
                <div class="p-2" *ngFor="let item of activeChat?.chatDocument; let idx = index">
                    <div class="flex spaceBetween docControlItem">
                        <span class="p-2 docText truncate">
                            <i class="pi pi-paperclip paperclipIcon mx-1"></i>
                            {{ item.documentName }}
                        </span>
                    </div>
                </div>
            </p-overlayPanel>
            <input
                type="file"
                class="form-control hidden"
                #imageuploadchat
                (change)="onUploadFiles($event)"
                accept=".png, .jpg, .jpeg, .gif, .bmp, .tiff, .webp"
            />

            <span *ngIf="activeChat?.chatState !== ChatStateInactive && activeChat?.chatState !== ChatStateArchived" class="p-input-icon-left textBox">
                <div class="chat-input-left-icon">
                    <i
                        *ngIf="selectedModel?.featuresSupported?.documentUpload !== false
                        && chatType !== openWebChatType
                        && chatType !== codeInterpreterChatType
                        && chatType !== ESGChatType
                        && chatType !== QECChatType
                        && chatType !== deepResearchChatType
                        && chatType !== quiltChatType
                        && !loadingChats && chatMessages?.length > 0
                        && chatDocsProcessingCount === 0
                        && !isImageUploadedInCurrentChat()"
                        class="pi pi-paperclip paperclipIcon editToolbarIcon"
                        (click)="opdocs.toggle($event)"
                        (keydown.enter)="opdocs.toggle($event)"
                    ></i>
                    <i
                    *ngIf="selectedModel?.featuresSupported?.imageUpload !== false
                    && chatType !== openWebChatType
                    && chatType !== codeInterpreterChatType
                    && chatType !== ESGChatType
                    && chatType !== QECChatType
                    && chatType !== deepResearchChatType
                    && chatType !== quiltChatType
                    && !loadingChats
                    && (chatMessages?.length > 0)
                    && activeChat?.chatDocument?.length===0
                    && chatDocsProcessingCount === 0"
                      class="pi pi-image paperclipIcon secondEditorIcon editToolbarIcon"
                      (click)="imageuploadchat.click()"
                      (keydown.enter)="imageuploadchat.click()"
                    ></i>

                    <button
                    *ngIf="chatType === ESGChatType && chatMessages?.length > 0 && !loadingChats"
                    class="button"
                    (click)="showDocuments()"
                    >
                        <i
                        class="bi bi-recycle paperclipIcon editToolbarIcon"
                        
                        ></i>
                    </button>
                    <ng-container *ngIf="chatType === QECChatType && chatMessages?.length > 0 && !loadingChats">
                        <button class="button" (click)="showDocuments()">
                            <i
                                *availableFor
                                class="pi pi-table paperclipIcon editToolbarIcon"
                            ></i>
                        </button>
                    </ng-container>

                </div>

               <div class="inputOptionsContainer" [ngClass]="{'inputOptionsContainer--tall': chatMessages?.length > 0}">                    
                    <span class="p-input-icon-right flex mr-0 align-items-end">    
                        <div #textarea id="inputText">
                            <angular-editor
                                #editorInput
                                [(ngModel)]="inputText"
                                (paste)="onPaste($event)"
                                [ngClass]="{'hide-toolbar': !showToolbar, 'formatIconMargin': chatMessages?.length > 0}"
                                class="inputtextbox"
                                [config]="editorConfig"
                                (ngModelChange)="onEditorChange($event)"
                            >
                            </angular-editor>
                        </div>
                    </span>
                    <div 
                        *ngIf="!loadingChats"
                        [ngClass]="chatMessages?.length===0 &&
                            (filesUploadedImgUrls?.length === 1) ? 'sendQueryBtntobottom':'sendQueryBtn'" 
                        class="inputbox-icon"
                    >
                        <button *ngIf="!generatingReplyBool" class="button" (click)="onQuestionSubmit()"
                                [pTooltip]="inputText?.trim()?.length ? 'Submit' : null"
                                tooltipPosition="bottom"
                                showDelay="300">
                            <i
                                [ngClass]="
                                    chatDocsProcessingCount>0||!inputText ||
                                    inputText?.trim()?.length === 0 ||
                                    !isActiveChat() ||
                                    (chatType === QECChatType &&
                                        ((activeChat?.chatId && !activeChat?.chatTables?.length) ||
                                        ( !activeChat?.chatId && 
                                        defaultWFDOTables.length === 0))
                                    )
                                        ? 'disableSend'
                                        : ''
                                "
                                class="bi bi-arrow-right-circle straightIconClass"
                            ></i>
                        </button>
                        <button
                            *ngIf=" generatingReplyBool &&(
                                    !getChatDocumentsLoader ||
                                    !sendQuestionLoader)
                                    " 
                            class="button inputbox-icon inputbox-icon--stopGenerate"
                            tabindex="0"
                            (click)="stopGeneration();"
                            (keydown.enter)="stopGeneration();"
                            (keydown.space)="stopGeneration();"
                        >
                            <i
                                pTooltip="Stop Generation"
                                tooltipPosition="top"
                                showDelay="300"
                                
                                class="pi pi-stop-circle stopGenerationIcon inside-spinner"
                            ></i>
                            <i
                                class="loaderGrey stopGenerationIcon"
                            ></i>
                    </button>
                    </div>
                    <div *ngIf="chatMessages?.length > 0 && chatType !== quiltChatType" class="model-placeholder-row">
                        <button type="button" class="selector-btn-inside-disable disabled-dropdown" disabled>
                          <span class="selector-label">{{displayModelName}}</span>
                          <i class="pi pi-chevron-down"></i>
                        </button>
                        <!-- Disabled prompt selector shown when chat is active and input area is hidden -->
                        <button
                          *ngIf="
                            chatType !== QECChatType &&
                            chatType !== ESGChatType &&
                            chatType !== openWebChatType &&
                            chatType !== codeInterpreterChatType &&
                            chatType !== deepResearchChatType &&
                            chatType !== quiltChatType"
                          type="button"
                          class="selector-btn-inside-disable disabled-dropdown"
                          disabled
                          style="margin-left: 8px;"
                        >
                          <span class="selector-label">{{selectedPromptTemplate?.label}}</span>
                          <i class="pi pi-chevron-down"></i>
                        </button>
                        <!-- Reasoning Mode Selector Disabled -->
                        <button
                          *ngIf="reasoningModeChatTypeConfig[chatType] !== false && selectedModel?.modelType === LLMReasoningModelType"
                          type="button"
                          class="selector-btn-inside-disable disabled-dropdown"
                          disabled
                          style="margin-left: 8px;"
                        >
                          <span class="selector-label">{{selectedReasoningMode?.label}}</span>
                          <i class="pi pi-chevron-down"></i>
                        </button>
                    </div>
                    <div
                        *ngIf="chatType === QECChatType && !loadingChats && chatMessages.length === 0"
                        class="inputOptions flex justify-content-start align-items-center mb-2 scroll-x"
                    >

                        <button
                            *availableFor
                            (click)="showDocuments()"
                            class="ml-2 p-button p-button-secondary"
                        >
                            <i class="pi pi-table mr-2"></i>Tables
                        </button>
                        <div class="model-selector-row-inside">
                        <button
                            class="model-selector-btn-inside"
                            type="button"
                            (click)="!isModelSelectionDisabled && modelDropdown.toggle($event)"
                            pTooltip="Model Selection"
                            tooltipPosition="bottom"
                            [disabled]="isModelSelectionDisabled"
                            [ngClass]="{'disabled-dropdown': isModelSelectionDisabled}">
                            <span class="selector-label">{{ displayModelName }}</span>
                            <i class="pi pi-chevron-down"></i>
                        </button>
                        <p-overlayPanel #modelDropdown [showCloseIcon]="false" [dismissable]="true" styleClass="dropdown-panel-inside">
                          <button type="button" *ngFor="let model of supportedLLMModels" class="dropdown-item-inside" (click)="onModelChange({ value: model }); modelDropdown.hide()">
                            <div class="dropdown-label">{{ model.model }}</div>
                            <div class="dropdown-desc">{{ model.description }}</div>
                          </button>
                        </p-overlayPanel>
                        </div>
                        <!-- Reasoning Mode Selector Dropdown -->
                        <div
                          class="reasoning-selector-row-inside"
                          *ngIf="reasoningModeChatTypeConfig[chatType] !== false && selectedModel?.modelType === LLMReasoningModelType"
                        >
                          <button
                            class="model-selector-btn-inside"
                            type="button"
                            (click)="reasoningDropdown.toggle($event)"
                            [ngClass]="{'disabled-dropdown': isPromptSelectionDisabled}"
                            pTooltip="LLM Reasoning Mode"
                            tooltipPosition="bottom"
                          >
                            <span class="selector-label">{{ selectedReasoningMode?.label }}</span>
                            <i class="pi pi-chevron-down"></i>
                          </button>
                          <p-overlayPanel #reasoningDropdown [showCloseIcon]="false" [dismissable]="true" styleClass="dropdown-panel-inside">
                            <button type="button" *ngFor="let mode of reasoningModeOptions" class="dropdown-item-inside" (click)="onReasoningModeChange(mode); reasoningDropdown.hide()">
                              <div class="dropdown-label">{{ mode.label }}</div>
                              <div class="dropdown-desc" *ngIf="mode.description">{{ mode.description }}</div>
                            </button>
                          </p-overlayPanel>
                        </div>
                        
                    </div>
                    <div
                        *ngIf="chatType === ESGChatType && !loadingChats && chatMessages.length === 0"
                        class="inputOptions flex justify-content-start align-items-center mb-2 scroll-x"
                    >

                        <button
                            (click)="showDocuments()"
                            class="ml-2 p-button p-button-secondary"
                        >
                            <i class="bi bi-recycle mr-2"></i>ESG Datasets
                        </button>
                        <div class="model-selector-row-inside" *ngIf="chatType !== deepResearchChatType">
                        <button
                            class="model-selector-btn-inside"
                            type="button"
                            (click)="!isModelSelectionDisabled && modelDropdown.toggle($event)"
                            pTooltip="Model Selection"
                            tooltipPosition="bottom"
                            [disabled]="isModelSelectionDisabled"
                            [ngClass]="{'disabled-dropdown': isModelSelectionDisabled || activeChat?.chatState === ChatStateActive}">
                            <span class="selector-label">{{ selectedModel?.model }}</span>
                            <i class="pi pi-chevron-down"></i>
                        </button>
                        <p-overlayPanel #modelDropdown [showCloseIcon]="false" [dismissable]="true" styleClass="dropdown-panel-inside">
                          <button type="button" *ngFor="let model of supportedLLMModels" class="dropdown-item-inside" (click)="onModelChange({ value: model }); modelDropdown.hide()">
                            <div class="dropdown-label">{{ model.model }}</div>
                            <div class="dropdown-desc">{{ model.description }}</div>
                          </button>
                        </p-overlayPanel>
                        </div>
                    </div>
                    <div
                        *ngIf="
                            chatType !== ESGChatType &&
                            chatType !== QECChatType &&
                            chatType !== quiltChatType &&
                            !loadingChats &&
                            chatMessages?.length === 0
                        "
                        class="inputOptions flex justify-content-start align-items-center mb-2 scroll-x"
                    >

                    <ng-container *ngIf="filesUploaded?.length===0 ">
                       <p-overlayPanel styleClass="settingsOverlay" #memoryChatOP>
                            <div class="flex-column">
                                <div class="mt-3 px-3 flex justify-content-between align-items-center w-100 ">

                                <div for="memorySwitch" class="small-switch-title"> <i class="bi bi-database mr-1"></i> Memory Chat (Beta)</div>
                                <p-inputSwitch
                                id="memorySwitch"
                                class="small-switch"
                                [(ngModel)]="memoryToggle"
                                (onChange)="onMemoryToggleChange($event)"
                                [disabled]="isMemoryChatToggleDisabled"
                                ></p-inputSwitch>


                                </div>
                                <p class="subText px-3 pt-[8px] pb-3">Leverages chat history for smarter, tailored responses</p>
                                <hr>
                                <div
                                    class="mt-3 px-3 flex justify-content-between align-items-center w-100"
                                    [ngClass]="chatType === openWebChatType ? 'disabledSwitch' : ''"
                                    >
                                    <label for="webSearchSwitch" class="small-switch-title">
                                        <i class="pi pi-globe mr-1"></i> Web Search
                                    </label>

                                    <p-inputSwitch
                                        id="webSearchSwitch"
                                        class="small-switch"
                                        [ngModel]="chatType === openWebChatType"
                                        (onChange)="emitUpdatedChatType({ label: 'QIQ Chat', type: openWebChatType })"
                                        [disabled]="
                                        chatType === codeInterpreterChatType ||
                                        chatType === deepResearchChatType ||
                                        chatDocsProcessingCount > 0 ||
                                        !(activeChat?.chatDocument?.length === 0 || !activeChat)
                                        "
                                    ></p-inputSwitch>
                                </div>

                                <p class="subText px-3 pt-[8px] pb-3">
                                This chat operates in an open web environment
                                </p>
                                <hr>
                                <div
                                    class="mt-3 px-3 flex justify-content-between align-items-center w-100"
                                    [ngClass]="chatType === codeInterpreterChatType ? 'disabledSwitch' : ''"
                                    >
                                    <label for="dsPlaygroundSwitch" class="small-switch-title">
                                        <i class="pi pi-code mr-1"></i> DS Playground
                                    </label>

                                    <p-inputSwitch
                                        id="dsPlaygroundSwitch"
                                        class="small-switch"
                                        [ngModel]="chatType === codeInterpreterChatType"
                                        (onChange)="
                                        emitUpdatedChatType({ label: 'QIQ Chat', type: codeInterpreterChatType })
                                        "
                                        [disabled]="
                                        chatType === openWebChatType ||
                                        chatType === deepResearchChatType ||
                                        chatDocsProcessingCount > 0 ||
                                        !(activeChat?.chatDocument?.length === 0 || !activeChat)
                                        "
                                    ></p-inputSwitch>
                                </div>

                                <p class="subText px-3 pt-[8px] pb-3">
                                This chat is interactive coding based playground
                                </p>
                                <hr>
                                <div
                                    class="mt-3 px-3 flex justify-content-between align-items-center w-100"
                                    [ngClass] = "chatType === deepResearchChatType ? 'disabledSwitch' : ''"
                                    >
                                    <label for="deepResearchSwitch" class="small-switch-title">
                                        <i class="pi pi-search mr-1"></i> Deep Research (Beta)
                                    </label>

                                    <p-inputSwitch
                                        id="deepResearchSwitch"
                                        class="small-switch"
                                        [ngModel]="chatType === deepResearchChatType"
                                        (onChange)="
                                        emitUpdatedChatType({ label: 'QIQ Chat', type: deepResearchChatType })
                                        "
                                        [disabled] = "
                                        chatType === openWebChatType ||
                                        chatType === codeInterpreterChatType ||
                                        chatDocsProcessingCount > 0 ||
                                        !(activeChat?.chatDocument?.length === 0 || !activeChat)
                                        "
                                    ></p-inputSwitch>
                                </div>

                                <p class="subText px-3 pt-[8px] pb-3">
                                This uses deep research model for comprehensive analysis
                                </p>

                            </div>
                        </p-overlayPanel>

                        <button
                        [disabled]=" !(chatType !== openWebChatType &&
                        chatType !== codeInterpreterChatType &&
                        chatType !== deepResearchChatType) || chatDocsProcessingCount >0  "
                            (click)="op.toggle($event)"
                            class="p-button p-button-secondary button-inputOption darker-icon custom-plus-button"
                            pTooltip="Add photos and files"
                            tooltipPosition="bottom"
                            showDelay="300"
                        >
                            <i class="pi pi-plus"></i>
                        </button>
                        <input
                            type="file"
                            class="form-control hidden"
                            #imageupload
                            (change)="onUploadFiles($event)"
                            accept=".png, .jpg, .jpeg, .gif, .bmp, .tiff, .webp"
                        />
                        
                         <button
                            (click)="memoryChatOP.toggle($event)"
                            class=" p-button p-button-secondary button-inputOption darker-icon custom-plus-button"
                            pTooltip="Tools"
                            tooltipPosition="bottom"
                            showDelay="300"
                        >
                            <i class="bi bi-sliders"></i>
                        </button>

                        <div class="model-selector-row-inside">
                            <button
                                class="model-selector-btn-inside"
                                type="button"
                                (click)="!isModelSelectionDisabled && modelDropdown.toggle($event)"
                                pTooltip="Model Selection"
                                tooltipPosition="bottom"
                                [disabled]="isModelSelectionDisabled"
                                [ngClass]="{'disabled-dropdown': isModelSelectionDisabled}">
                                <span class="selector-label">{{ displayModelName }}</span>
                                <i class="pi pi-chevron-down"></i>
                            </button>
                            <p-overlayPanel #modelDropdown [showCloseIcon]="false" [dismissable]="true" styleClass="dropdown-panel-inside">
                            <button type="button" *ngFor="let model of supportedLLMModels" class="dropdown-item-inside" (click)="onModelChange({ value: model }); modelDropdown.hide()">
                                <div class="dropdown-label">{{ model.model }}</div>
                                <div class="dropdown-desc">{{ model.description }}</div>
                            </button>
                            </p-overlayPanel>
                        </div>
                        <!-- Prompt Template Selector Dropdown -->
                        <div
                          class="prompt-selector-row-inside"
                          *ngIf="
                            chatType !== QECChatType &&
                            chatType !== ESGChatType &&
                            chatType !== openWebChatType &&
                            chatType !== codeInterpreterChatType &&
                            chatType !== deepResearchChatType &&
                            chatType !== quiltChatType"
                        >
                          <button
                            class="model-selector-btn-inside"
                            type="button"
                            (click)="!isPromptSelectionDisabled && promptDropdown.toggle($event)"
                            [ngClass]="{'disabled-dropdown': isPromptSelectionDisabled}"
                            [disabled]="isPromptSelectionDisabled"
                            pTooltip="Persona Selection"
                            tooltipPosition="bottom">
                            <span class="selector-label">{{ selectedPromptTemplate?.label }}</span>
                            <i class="pi pi-chevron-down"></i>
                          </button>
                          <p-overlayPanel #promptDropdown [showCloseIcon]="false" [dismissable]="true" styleClass="dropdown-panel-inside">
                            <button type="button" *ngFor="let template of promptTemplates" class="dropdown-item-inside" (click)="onPromptTemplateChange(template); promptDropdown.hide()">
                              <div class="dropdown-label">{{ template.label }}</div>
                              <div class="dropdown-desc" *ngIf="template.description">{{ template.description }}</div>
                            </button>
                          </p-overlayPanel>
                        </div>
                        <!-- Reasoning Mode Selector Dropdown -->
                        <div
                          class="reasoning-selector-row-inside"
                          style="display: inline-block; margin-left: 8px;"
                          *ngIf="reasoningModeChatTypeConfig[chatType] !== false && selectedModel?.modelType === LLMReasoningModelType"
                        >
                          <button
                            class="model-selector-btn-inside"
                            type="button"
                            (click)="reasoningDropdown.toggle($event)"
                            [ngClass]="{'disabled-dropdown': isPromptSelectionDisabled}"
                            pTooltip="LLM Reasoning Mode"
                            tooltipPosition="bottom"
                          >
                            <span class="selector-label">{{ selectedReasoningMode?.label }}</span>
                            <i class="pi pi-chevron-down"></i>
                          </button>
                          <p-overlayPanel #reasoningDropdown [showCloseIcon]="false" [dismissable]="true" styleClass="dropdown-panel-inside">
                            <button type="button" *ngFor="let mode of reasoningModeOptions" class="dropdown-item-inside" (click)="onReasoningModeChange(mode); reasoningDropdown.hide()">
                              <div class="dropdown-label">{{ mode.label }}</div>
                              <div class="dropdown-desc" *ngIf="mode.description">{{ mode.description }}</div>
                            </button>
                          </p-overlayPanel>
                        </div>
                        <input
                            type="file"
                            class="form-control hidden"
                            #fileUploadDocMainInput multiple
                            (change)="onFIleuploadForDocChat($event)"
                            accept=".pdf, .ppt, .pptx, .docx, .txt, .csv, .xlsx, .xls"
                        />
                        <p-overlayPanel class="overlayStyles uploadstyles" style="padding: 0px !important;"  #op>
                            <div>
                                <div class="m-2">
                                <button
                                    *ngIf="
                                    selectedModel?.featuresSupported?.imageUpload !== false &&
                                    chatType !== codeInterpreterChatType &&
                                    chatType !== ESGChatType &&
                                    chatType !== QECChatType &&
                                    chatType !== openWebChatType &&
                                    chatType !== deepResearchChatType &&
                                    (activeChat?.chatDocument?.length === 0 || !activeChat) &&
                                    filesUploaded?.length === 0 &&
                                    (chatDocumentList?.length === 0 || !chatDocumentList)
                                    "
                                    [disabled]="
                                    chatDocsProcessingCount > 0 ||
                                    !(activeChat?.chatDocument?.length === 0 || !activeChat)
                                    "
                                    class="p-button p-button-secondary attachBtn w-full text-left"
                                    (click)="
                                    imageupload.click();
                                    op.hide()
                                    "
                                >
                                    <i class="pi pi-image mr-2"></i>
                                    Load an image
                                </button>
                                </div>
                                                   <hr *ngIf="
                                    selectedModel?.featuresSupported?.imageUpload !== false &&
                                    chatType !== codeInterpreterChatType &&
                                    chatType !== ESGChatType &&
                                    chatType !== QECChatType &&
                                    chatType !== openWebChatType &&
                                    chatType !== deepResearchChatType &&
                                    (activeChat?.chatDocument?.length === 0 || !activeChat) &&
                                    filesUploaded?.length === 0 &&
                                    (chatDocumentLists?.length === 0 || !chatDocumentLists)
                                    ">
                                <div class="m-2">
                                <button
                                    *ngIf="
                                        selectedModel?.featuresSupported?.documentUpload !== false
                                    "
                                    class="p-button p-button-secondary attachBtn w-full text-left"
                                    (click)="fileUploadDocMainInput.click(); op.hide()"
                                >
                                    <i class="bi bi-upload mr-2"></i> Load documents from
                                    computer
                                </button></div>
                                <hr *ngIf="
                                        selectedModel?.featuresSupported?.documentUpload !== false
                                    ">
                                <div class="m-2">
                                <button
                                    *ngIf="
                                        selectedModel?.featuresSupported?.documentUpload !== false
                                    "
                                    class="p-button p-button-secondary attachBtn w-full text-left mt-1"
                                    (click)="showDocuments(); op.hide()"
                                >
                                    <i class="bi bi-folder mr-2"></i>
                                    Select documents from QIQ
                                </button></div>
                            </div>
                        </p-overlayPanel>
                        
                      </ng-container>


                    </div>
                </div>
            </span>
            <div class="ai-disclaimer">
                QIQ can make mistakes. Always review the accuracy of responses
            </div>
        </div>
    </section>
</main>
<app-documents-dialogbox
    (visibleChange)="onDialogClose($event)"
    [visible]="showSearchDocumentsBool"
    [activeChatParent]="activeChat"
    (reloadedchatDocs)="updateChatDocs($event)"
></app-documents-dialogbox>

<app-tables-main
    (visibleChange)="onDialogClose($event)"
    [visible]="showQECDocumentsBool"
    [activeChatParent]="activeChat"
></app-tables-main>

<app-esgdata-main
    (visibleChange)="onDialogClose($event)"
    [visible]="showESGDocumentsBool"
    [activeChatParent]="activeChat"
></app-esgdata-main>
